import {Stack, Typography, useTheme} from '@mui/material';
import React from 'react';

import {IconIllustration} from 'presentation/components';
import {useMediaQueries} from 'presentation/pages';
import {ContentStateProps} from './types';

function ContentState({
	variant = 'default',
	customIconName,
	description,
	footer,
	title,
	...stackProps
}: ContentStateProps) {
	const {isTablet} = useMediaQueries();
	const {palette} = useTheme();

	return (
		<Stack
			gap={2}
			alignItems="center"
			{...stackProps}
			padding={isTablet ? '32px 16px' : (stackProps.padding ?? 6)}>
			<IconIllustration variant={variant} size="big" customIconName={customIconName} />
			{title ? (
				<Typography variant="h6" color={palette.text.primary} textAlign="center">
					{title}
				</Typography>
			) : null}
			{description ? (
				<Typography color={palette.text.primary} textAlign="center">
					{description}
				</Typography>
			) : null}
			{footer}
		</Stack>
	);
}

export {ContentState};
